<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="overview">
    <div class="item-block" v-for="(item, index) in showData" :key="index">
      <div class="item">
        <div class="icon" v-html="item.icon"></div>
        <div class="hr"></div>
        <div class="value">
          <span v-if="item.name">{{ item.name }}：</span>
          <span>{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { computed } from 'vue';
import { getOverviewData, _testOverviewData } from './index';

const showData = computed(() => {
  return getOverviewData(_testOverviewData, false, false, false);
});
</script>
<style lang="scss" scoped>
@import './index.scss';
.item-block {
  padding: 18px 0;
  margin: 0 100px;
}
.item {
  display: flex;
  align-items: center;

  .icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 53px;
    height: 53px;
    background: var(--theme-color-1);
    border-radius: 50%;
    opacity: 1;
    ::v-deep {
      svg {
        --theme-color-1: #fff;
      }
    }
  }
  .hr {
    flex-shrink: 0;
    width: 90px;
    height: 1px;
    background-color: var(--theme-color-1);
  }
  .value {
    padding: 18px 28px;
    font-size: 16px;
    color: #3e3e3e;
    border: 1px solid var(--theme-color-1);
    flex-grow: 1;
    border-radius: 47px;
    position: relative;
    overflow: hidden;
    &::after {
      content: '';
      width: 100%;
      height: 100%;
      background-color: var(--theme-color-1);
      opacity: 0.1;
      left: 0;
      top: 0;
      position: absolute;
      border-radius: 47px;
    }
  }
}
</style>
